import Vue from 'vue'
import VueRouter from 'vue-router'
import ContentSafe from '../views/ContentSafe.vue'

// vue-meta
import meta from 'vue-meta'
Vue.use(meta)
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/Home'),
  },
  {
    path: '/aptitude-safe',
    name: 'AptitudeSafe',
    component: () => import('@/views/aptitude_safe/AptitudeSafe'),
  },
  {
    path: '/audit-platform',
    name: 'AuditPlatform',
    component: () => import('@/views/audit_platform/AuditPlatform'),
  },
  {
    path: '/content-safe',
    name: 'ContentSafe',
    component: ContentSafe,
  },
  {
    path: '/:w+',
    redirect: { name: 'Home' },
  },
]

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

export default router
